import React from 'react';

const ServicesArea = () => {
  return (
    <div
      className="vs-services-style2 space bg-second-theme-color"
      style={{ backgroundImage: "url('/img/bg/services-style2-bg.png')" }}
    >
      <img
        src="/img/icons/cloud.png"
        alt="icon"
        className="vs-services-style2-icon-1 animate-parachute"
      />
      <img
        src="/img/icons/ballon-sclation.png"
        alt="icon"
        className="vs-services-style2-icon-2 animate-parachute"
      />

      <div className="container py-5">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle fade-anim" data-direction="bottom">
                Reliable & Comfortable
              </span>
              <h2 className="sec-title text-white fade-anim" data-direction="top">
                Mauli Cab Services
              </h2>
            </div>
          </div>
        </div>

        <div className="row g-4 gx-xxl-5 align-items-center align-items-xl-start overflow-hidden">
          <div className="col-xl-5">
            <div className="service-thumb-box fade-anim" data-direction="top">
              <img
                src="/images/img8.jpg"
                alt="service-thumb"
                className="w-100"
                data-speed=".8"
              />
            </div>
          </div>

          <div className="col-xl-7">
            <div className="service-content-box">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-one-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-one"
                    type="button"
                    role="tab"
                    aria-controls="pills-one"
                    aria-selected="true"
                  >
                    LOCAL & OUTSTATION
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-two-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-two"
                    type="button"
                    role="tab"
                    aria-controls="pills-two"
                    aria-selected="false"
                  >
                    AIRPORT TRANSFERS
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-three-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-three"
                    type="button"
                    role="tab"
                    aria-controls="pills-three"
                    aria-selected="false"
                  >
                    CORPORATE TRAVEL
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="pills-tabContent">
                {/* Tab 1 */}
                <div
                  className="tab-pane fade show active"
                  id="pills-one"
                  role="tabpanel"
                  aria-labelledby="pills-one-tab"
                >
                  <TabContent
                    title="Local & Outstation Rides"
                    description="Mauli Cab provides prompt and comfortable travel for city rides and intercity trips. Our fleet is available 24/7 to make your journey smooth and reliable."
                    ridesCompleted={1200} // for Local & Outstation rides
                  />
                </div>

                {/* Tab 2 */}
                <div
                  className="tab-pane fade"
                  id="pills-two"
                  role="tabpanel"
                  aria-labelledby="pills-two-tab"
                >
                  <TabContent
                    title="Airport Transfers"
                    description="Never miss a flight with Mauli Cab’s timely airport transfer services. We ensure smooth pickups and drop-offs to and from all major airports."
                    ridesCompleted={1850} // for Airport Transfers
                  />
                </div>

                {/* Tab 3 */}
                <div
                  className="tab-pane fade"
                  id="pills-three"
                  role="tabpanel"
                  aria-labelledby="pills-three-tab"
                >
                  <TabContent
                    title="Corporate & Business Travel"
                    description="Mauli Cab offers professional travel solutions for corporate clients. Experience clean, punctual, and executive-class service tailored for your business needs."
                    ridesCompleted={1561} // for Corporate Travel
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TabContent = ({ title, description, ridesCompleted }) => (
  <>
    <h3 className="service-title text-white-color">{title}</h3>
    <p>{description}</p>
    <div className="service-info">
      <div className="jurny">
        <div className="jurny-info">
          <h2 className="jurny-number">
            {ridesCompleted}<em>+</em>
          </h2>
          <h5 className="title">rides completed successfully</h5>
        </div>
        <div className="info-download-area">
          <div className="download-img">
            <img src="/img/services/services-info-download-img.png" alt="img" />
          </div>
          <div className="download-info">
            <h6 className="download-title text-white-color">Service Overview</h6>
            <a href="/img/services/services-thumb-2-1.png" download>
              <i className="fa-regular fa-arrow-down-to-line"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="service-img">
        {/* <img src="/img/services/services-thumb-2-1.1.png" alt="img" /> */}
        {/* <img src="/img/services/services-thumb-2-1.abs.png" alt="img" /> */}
      </div>
    </div>
  </>
);

export default ServicesArea;
